import { parseBool } from "../../lib/calculations";
import { BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { FormItem } from "@/cs-ts-bridge/ts/form-item";
import { BaseElementDef, BaseElementDefBase } from "./BaseElementDef";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { WorkflowSwitchSettings } from "@cs-ts/workflow-switch-settings";
import { CalculationContext } from "./__CalculationContextInterface";

export default class WorkflowSwitchDef extends BaseElementDef<WorkflowSwitchSettings, FormDefinitionItem<WorkflowSwitchSettings>, FormItem> {
    declare _branchSubjects: Record<string, BehaviorSubject<boolean>>;

    constructor(parentElement: BaseElementDefBase | null, elementData: FormItem, definitionData: FormDefinitionItem<WorkflowSwitchSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = "MI.Common.DynamicForms.Models.DFWorkflowSwitch"; // TODO - not hardcoded?
        this._branchSubjects = null!;
        setTimeout(() => {
            this.initBranchSubjects();
        }, 0);
    }

    _currentBranch() {
        this.initBranchSubjects();
        if (this._branchSubjects != null) {
            for (const branchId of Object.keys(this._branchSubjects)) {
                if (this._branchSubjects[branchId].getValue()) {
                    return this.children.find(i => i.id == branchId)!;
                }
            }
        }
        return this.children.find(i => i.id!.endsWith("_ELSE"))!;
    }

    initBranchSubjects() {
        if (this._branchSubjects == null) {
            this._branchSubjects = {};
            for (const branch of this.definition.settings.branches ?? []) {
                const branchSubject = new BehaviorSubject(false);
                this._branchSubjects[branch.branchId!] = branchSubject;
                const calcId = branch.calculationId!;
                const result = this.resolveCalculation(calcId);
                result
                    .pipe(
                        //tap(a => { debugger; }),
                        map(value => value.reduce((a, i) => a || parseBool(i) === 1, false)),
                        //tap(a => { debugger; })
                    )
                    .subscribe(branchSubject);
            }
        }
    }

    _getElementsByFilter(func: (i: BaseElementDefBase) => boolean, result: []) {
        return this._currentBranch()._getElementsByFilter(func, result);
    }

    getElementByVmId(vmId: string) {
        return this._currentBranch().getElementByVmId(vmId);
    }

    _getElementsById$(id: string, contextVmId?: string) {
        return this._currentBranch()._getElementsById$(id, contextVmId);
    }
}
